import { TFunction, useTranslation } from '@hopin-team/provider-translation';

type TranslationPrefix = 'addToCalendar' | 'event' | 'common' | 'reception';
export type T = (
  key: string,
  interpolationMap?: Record<string, any> | undefined,
) => string;

export const useLocales = (prefix: TranslationPrefix) => {
  const { t } = useTranslation();
  const getTranslationWithPrefix: TFunction = (key, interpolationMap) =>
    t(`${prefix}.${key}`, interpolationMap);
  return { t: getTranslationWithPrefix };
};
